export const LSKEY_TOKEN = 'token'